/* src/app/forms/wizard-configuracao/config-log/config-log.component.scss */
:host {
  display: flex;
  height: 100%;
  flex-direction: column;
  overflow: auto;
  margin: 8px;
}
.view-component {
  margin: 0px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
.maindiv {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
/*# sourceMappingURL=config-log.component.css.map */
